import React from "react";
import AllPosters from "../AllSessions";
import "./index.css";

const Presentation = ({ config }) => {
  return (
    <div>
      <AllPosters config={config} header={
      <div className="sessions-header">
        <img alt="logo header" className="header-logo" src='https://immunologia2024.pl/wp-content/uploads/2023/11/Group-77-1024x109.png'/>
        <div className="header-title">Plakaty</div>
        </div>
        } />
    </div>
  );
};

export default Presentation;
